//import React from "react";
import React, { useMemo, useState, useEffect } from "react";
import { Button } from "../../../common/Button/Button";
import moment from "moment";
import { getUser } from "../../../utils/localStorage";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../../common/Pagination/Pagination";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import find from "lodash/find";
import { toast } from "react-toastify";
import copysvg from "./../../../assets/arrow_copy.svg";
import arrow_right from "../../../assets/ic_header_arrow_right.svg";
import arrow_left from "../../../assets/ic_header_arrow_left.svg";
const ReactTableFixedColumns = withFixedColumns(ReactTable);
//sEmailAddress
export default function  ServicessDetailsTable(props) {
    
	const LS_FIELDS = [
		{ key: "leadsquared_lead_url", name: "LS URL"},
		{ key: "FirstName", name: "First Name" },
		{ key: "LastName", name: "Last Name" },

		{ key: "EmailAddress", name: "Email Address" },
		{ key: "Phone", name: "Phone" },
		{ key: "mx_City", name: "City" },
		{ key: "mx_State", name: "State" },

		{ key: "Mobile", name: "Mobile" },

		{ key: "mx_Contact_URL_Email", name: "Conatct URL Email" },

		{ key: "mx_Contact_URL_Phone_1", name: "Contact URL Phone 1" },

		{ key: "mx_Contact_URL_Phone_2", name: "Contact URL Phone 2" },

		{ key: "CreatedOn", name: "Created On" },

		{ key: "mx_DND_Consent_Expiry_Date", name: "DND Consent Expiry Date" },
		{ key: "OwnerIdName", name: "Owner Id Name" },
		{ key: "Source", name: "Lead Source" },

		{ key: "mx_Source_Specific", name: "Source Specific" },
		{ key: "mx_Campaign_specific", name: "Campaign_Specific" },
		{ key: "ProspectStage", name: "Lead Stage" },

		{ key: "mx_substage1", name: "Substage" },
		{ key: "mx_Reasons_for_No_Show", name: "Reason for no show" },
		{ key: "mx_Reasons_for_Case_Closed", name: "Reason for case closed" },

		{ key: "LeadAge", name: "Lead Age" },

		{ key: "mx_Latest_VOC_Member", name: "Latest VOC Member" },
		{ key: "mx_Gender", name: "Gender" },

		{ key: "mx_Benefited_Channel", name: "Benefited Channel" },
		{ key: "mx_SelfRegisteredOnWebsite", name: "SelfRegisteredOnWebsite" },
		{ key: "mx_Udyog_Guide", name: "Udyog Guide" },

		// { key: "ProspectAutoId", name: "Prospect Auto Id" },
	];
	/**
	 * city, area of operation,  udyog guide, counsellor
	 */
	/**
	 * {moment(moment.utc(e["dtServiceProgression"]).toDate()).format(
                "MMMM Do YYYY, h:mm:ss a"
              )}
	 */
	const LS_DATE_FIELDS = ["CreatedOn", "mx_DND_Consent_Expiry_Date"];
	const renderServicesTableLS = () => {
		if (!props.data) return;
		let temp = props.data.map((e, index) => {
			let temp1 = Object.entries(LS_FIELDS).map(([key, value], index) => {
				if (index < 11) {
					return (

						<div 
							style={{
								borderBottom: "1px solid #CCCCCC",
                                //borderRight:"1px solid #CCCCCC",
                                //borderLeft:"1px solid #CCCCCC",
                                borderTop:"1px solid #CCCCCC",
                                borderWidth:"1px solid #CCCCCC",
                                marginRight:"0px",
                                marginLeft:"-1px",
                                
                            
                                
							}}
							className="row"
									
						>
							<div className="col-md-2">
								<span className="ml-10">{value["name"]}:</span>
							</div>

							    <div className="col-md-4">
								{value["key"] === "leadsquared_lead_url" ? (
									<a href={e[value["key"]]} target="_blank">
										{" "}
										LS URL{" "}
									</a>
								) : value["key"] === "mx_Contact_URL_Email" ||
								  value["key"] === "mx_Contact_URL_Phone_1" ||
								  value["key"] === "mx_Contact_URL_Phone_2" ? (
									<a href={e[value["key"]]} target="_blank">
										{" "}
										{e[value["key"]]}
									</a>
								) : (
									<span>{e[value["key"]]}</span>
								)}
							</div>
							<div 
                            className="col-md-3 borderleft">
								<span>{LS_FIELDS[11 + index]["name"]}</span>
							</div>
							<div className="col-md-3">
								{LS_DATE_FIELDS.includes(value["key"]) ? (
									<span>
										{moment(
											moment
												.utc(
													e[
														LS_FIELDS[11 + index][
															"key"
														]
													]
												)
												.toDate()
										).format("MMMM Do YYYY, h:mm:ss a")}
									</span>
								) : (
									<span>
										{e[LS_FIELDS[11 + index]["key"]]}
									</span>
								)}
							</div>
						</div>
					);
				}
				if (index > 23) {
					return (
						<div className="row">
							<div className="col-md-3">
								<></>
							</div>

							<div className="col-md-3">
								<></>
							</div>
							<div
								className="col-md-3"
								style={{
									borderBottom: "1px solid #CCCCCC",
                                    borderLeft:"1px solid #CCCCCC",
                                    maxWidth:"24%",
                                    
								}}
							>
								<span>{LS_FIELDS[index]["name"]}</span>
							</div>
							<div
								className="col-md-3"
								style={{
									borderBottom: "1px solid #CCCCCC",
                                    
                                     
								}}
							>
								<span>{e[LS_FIELDS[index]["key"]]}</span>
							</div>
						</div>
					);
				}
			});
			return (
				<div
					// style={{
					// 	marginBottom: "50px",
					// 	//borderBottom: "1px solid grey",
                    //     borderBottom: "1px solid #CCCCCC",
                    //     borderRight:"1px solid #CCCCCC",
                    //     borderLeft:"1px solid #CCCCCC",
                    //     borderTop:"1px solid #CCCCCC",
					// }}
				>
					<div>{temp1}</div>
				</div>
			);
		});

		return <div style={{
             marginBottom: "50px",
            // //borderBottom: "1px solid grey",
              borderBottom: "1px solid #CCCCCC",
              borderRight:"1px solid #CCCCCC",
              borderLeft:"1px solid #CCCCCC",
              marginRight:"-25px",
              marginLeft: "25px",
              
            // borderTop:"1px solid #CCCCCC",
        }}>{temp}</div>;
	};


    //Service in LPM //
	const renderServicesTableLPM = () => {
		if (!props.data) return;
		let temp = props.data.map((e) => {
			 
		});		
	};

	const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

	const [columnPage,setcolumnPage] =useState(0);
	const renderServicesTableColumnsLPM = () => {

		var columns= [];
		
		if(columnPage==0)
		{
            columns.push(
                {
                    id: "sServiceCode",
                    Header: "Service Name + Service ID",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        {/* <span>{getServiceName(original)}</span>
                        <br></br> */}
						<span>{original["sServiceName"]}</span>
                        
                        
                        <br></br>
                        <span>ID: {original["nResourceInstanceId"]}</span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Package Details",
                    headerStyle:{'whiteSpace': 'unset','width':'10%'},
                    accessor: "sServiceCode",
                    width: 150,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                         <span>{original["sPackageOfferTitle"]?original["sPackageOfferTitle"]:""}</span>
                        <br></br>
                        
                        <br></br>
                        <span>{original["nPackageInstanceId"]?
                             (
                                 `ID: ${original["nPackageInstanceId"]}`):""}
                        </span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Business Details",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    width: 150,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        
						<span> {original["business_sector_name"]}</span>
						<br></br><br></br>
						<span>{original["sBusinessName"]}</span>                          
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Service Status",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
					<span>
					{original["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}}  title={original["sSRCancellationReason"]?
								original["sSRCancellationReason"] ==="Other"? 
								original["sSRCancellationReasonOtherDescription"]: 
								original["sSRCancellationReason"]:""}>{original["refSRState"]}</span>):(original["refSRState"])}
					</span>
                            
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    // Header: "Followup Detail ",
                    Header:
                    <div>Followup Detail
                    <br></br>
                    <img
                        alt=""
                        src={arrow_right}
                        height={"20px"}
                        width={"20px"}
                        className="conv-float-right"
                        onClick={()=>{
                            setcolumnPage(1);
                        }}
                    />
                </div>,
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    width: 210,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                         
						<span>{original["sFollowupAction"]}</span>
                        
                        <br></br> 
                        <span>{moment(moment.utc(original["dtFollowupOn"]).toDate()).format(
							"Do MMMM YYYY, h:mm:ss a"
						)}</span>
                              
                    </>
                )				
                },
                // {
                //     id: "sServiceCode",
                //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'10%'},
                //     Header: 
                //     <div>HH Email
                //         <br></br>
                //         <img
                //             alt=""
                //             src={arrow_right}
                //             height={"20px"}
                //             width={"20px"}
                //             className="conv-float-right"
                //             onClick={()=>{
                //                 setcolumnPage(1);
                //             }}
                //         />
                //     </div>,
                //     accessor: "sServiceCode",
                //     width: 250,
				// 	Cell:({original})=>
				// 	(
				// 		<>
				// 			{/* <span>{getServiceName(original)}</span>
				// 			<br></br> */}
				// 			<span>{original["refHH"]}</span>
								
				// 		</>
				// 	)				
                // },
                 
            );
        }
		else 
		{
            columns.push(
                {
                    id: "sServiceCode",
                    Header: "Service Name + Service ID",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
                    width: 240,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        {/* <span>{getServiceName(original)}</span>
                        <br></br> */}
						<span>{original["sServiceName"]}</span>
                        
                        <br></br>
                        <span>ID: {original["nResourceInstanceId"]}</span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Package Details",
                    headerStyle:{'whiteSpace': 'unset','width':'10%'},
                    accessor: "sServiceCode",
                    width: 150,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                         <span>{original["sPackageOfferTitle"]?original["sPackageOfferTitle"]:""}</span>
                        <br></br>
                        
                        <br></br>
                        <span>{original["nPackageInstanceId"]?
                             (
                                 `ID: ${original["nPackageInstanceId"]}`):""}
                        </span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Service Facilitator",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        
						<span>{original["refFacilitator"]
							? original["refFacilitator"]
							: ""}
						</span>
                        
                       
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Facilitator Status",
                    headerStyle:{'whiteSpace': 'unset','width':'10%'},
                    accessor: "sServiceCode",
                    width: 100,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        
						<span>{original["existing_service_facilitator"]
							? original["existing_service_facilitator"]["is_active"]
								? original["existing_service_facilitator"][
										"out_of_office"
								  ]
									? "Out of Office"
									: "Active"
								: "Deactivated"
							: ""}
						</span>
                        
                         
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "SR Email ID",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 250,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        <div className={"conv-float-left"}>
                                <div>
                                    <span className="conv-float-left lpm-service-grid-key"></span>
                                    {
                                        original.sEmailAddress?
                                        (
                                            <>
                                                <img
                                                    alt="copy"
                                                    src={copysvg}
                                                    height={"20px"}
                                                    width={"16px"}
                                                    className="con-cursor-pointer conv-mr13 conv-ml10"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        copyToClipboard(original.sEmailAddress);
                                                        toast(`${
                                                            original.sFirstName ? 
                                                            original.sFirstName :
                                                            ""
                                                        }${' '}
                                                        ${
                                                            original.sLastName ? 
                                                            original.sLastName :
                                                            ""
                                                        }'s Email Copied!`, {
                                                            autoClose: 5000,
                                                            type: toast.TYPE.SUCCESS,
                                                        });
                                                    }}
                                                />
                                                <span className="lpm-service-grid-value" style={{wordBreak:"break-all",float:"right"}}>
                                                    
                                                    {
                                                        original.sEmailAddress
                                                    }
                                                </span><br></br>
                                            </>
                                        )
                                        :
                                        ("NA")
                                    }
                                </div>
                                <div style={{"clear":"both"}}></div>
                                <div className="conv-mt10">
                                <span className="conv-float-left conv-mr5 lpm-service-grid-key"></span>
                                    {
                                        original.sContactNumber?
                                        (
                                            <>
                                                <img
                                                    alt="copy"
                                                    src={copysvg}
                                                    height={"20px"}
                                                    width={"16px"}
                                                    className="con-cursor-pointer conv-mr13 conv-ml10"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        copyToClipboard(original.sContactNumber);
                                                        toast(`${
                                                            original.sFirstName ? 
                                                            original.sFirstName :
                                                            ""
                                                        }${' '}
                                                        ${
                                                            original.sLastName ? 
                                                            original.sLastName :
                                                            ""
                                                        }'s Contact Copied!`, {
                                                            autoClose: 5000,
                                                            type: toast.TYPE.SUCCESS,
                                                        });
                                                    }}
                                                />
                                                <span className="lpm-service-grid-value" style={{wordBreak:"break-all",float:"right",width:"185px"}}>										
                                                    {
                                                        original.sContactNumber
                                                    }
                                                </span>
                                            </>
                                        )   
                                        :
                                        ("")
                                    }
                                </div>
                            </div>
                    </>
                )				
                },
                  
                {
                    id: "sServiceCode",
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'20%'},
                    Header: 
                    <div>SR User ID
                    {/* <br></br>
                    <img
                        alt=""
                        src={arrow_left}
                        height={"20px"}
                        width={"20px"}
                        className="conv-float-right"
                        onClick={()=>{
                            setcolumnPage(0);
                        }}
                    /> */}
                </div>,
                    accessor: "Delivered_to_Signed_Up",
                    width: 100,
					Cell:({original})=>
					(
						<>
		 
							<span>{original["nUserId"]}</span>     
						</>
					)				
                },
                {
                    id: "sServiceCode",
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'5%'},
                    Header: 
                    <div>Notes
                   <br></br>
                    <img
                        alt=""
                        src={arrow_left}
                        height={"20px"}
                        width={"20px"}
                        className="conv-float-right"
                        onClick={()=>{
                            setcolumnPage(0);
                        }}
                    />
                </div>,
                    accessor: "Delivered_to_Signed_Up",
                    //width: 200,
                    width: 150,
					Cell:({original})=>
					(
						<>
                            <Button onClick={() => props.toggleLPMNotesModal(original)}>
							    Add Notes
						    </Button>     
						</>
					)				
                },
            );
        }


		return  (
			
			
			<div className="spled-container fix-filter">
			<div className="spled-container">
				<div className={`service-partner spled-container`}>
			 	  <ReactTableFixedColumns 
				   columns={columns} 
				   data={props.data || []} 
				   pageSize={props.data.length}
				   sortable={false}
				   showPagination={false}
				   style={{overflowY: "initial",height: "280px"}}			
				   className="-striped hide-scrollbar"
				   />

				 </div>
				</div>
				 </div>
			 	 
				 
			   );
	};

    //End Service in LPM//


    //Service in spm section-A//
	const renderServicesTableColumnsSPMSectionA = () => {
		var columns= [];
		if(columnPage==0)
		{
            columns.push(
                {
                    id: "sServiceCode",
                    Header: "Service Name + Service ID",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        {/* <span>{getServiceName(original)}</span>
                        <br></br> */}
						<span> {original["refServiceType"]?.["sServiceName"]}</span>
                        
                        
                        <br></br>
                        <span> ID: {original["nResourceInstanceId"]}</span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Package Details",
                    headerStyle:{'whiteSpace': 'unset','width':'10%'},
                    accessor: "sServiceCode",
                    //width: 150,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                         <span>{original["sPackageOfferTitle"]?original["sPackageOfferTitle"]:""}</span>
                        <br></br>
                        
                        <br></br>
                        <span>{original["nPackageInstanceId"]?
                             (
                                 `ID: ${original["nPackageInstanceId"]}`):""}
                        </span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Business Details",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                   // width: 150,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        
						<span> {original["refBusinessSectorNew"] && original["refBusinessSectorNew"]["sSectorName"]}</span>
						<br></br><br></br>
						<span>{original["sBusinessName"]}</span>                          
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Service Status",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
					<span>
					{original["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}}  title={original["sServiceCancellationReason"]?
								original["sServiceCancellationReason"] ==="Other"? 
								original["sServiceCancellationReasonOtherDescription"]: 
								original["sServiceCancellationReason"]:""}>{original["refSRState"]}</span>):(original["refSRState"])}
					</span>
                    
                            
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Followup Detail ",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                   // width: 210,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                         
                        <span>{original["sFollowupAction"]}</span>

                        
                        
                        <br></br>
                        <span>{(original["dtFollowupOn"]?moment(moment.utc(original["dtFollowupOn"]).toDate()).format(
							"Do MMMM YYYY, h:mm:ss a"
						):null)}</span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'10%'},
                    Header: 
                    <div>SR Email ID + User ID
                        <br></br>
                        <img
                            alt=""
                            src={arrow_right}
                            height={"20px"}
                            width={"20px"}
                            className="conv-float-right"
                            onClick={()=>{
                                setcolumnPage(1);
                            }}
                        />
                    </div>,
                    accessor: "sServiceCode",
                    width: 250,
					Cell:({original})=>
					(
						<>
							
							<span>{original["sEmailAddressOrigin"]}</span>  
							<br></br><br></br>

							<span className="conv-float-right">{original["nUserId"]}</span>
							 
							<span>{original["sContactNumber"]}</span>
							<br></br>
							
								
						</>
					)				
                },
                 
            );
        }
		else 
		{
            columns.push(
                {
                    id: "sServiceCode",
                    Header: "Service Name + Service ID",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        {/* <span>{getServiceName(original)}</span>
                        <br></br> */}
						{/* <span>{original["sServiceName"]}</span>
                        
                        <br></br> */}
                        <span>{original["refServiceType"]?.["sServiceName"]}</span>

                        <br></br>
                        <span> ID: {original["nResourceInstanceId"]}</span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Package Details",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 150,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                         <span>{original["sPackageOfferTitle"]?original["sPackageOfferTitle"]:""}</span>
                        <br></br>
                        
                        <br></br>
                        <span>{original["nPackageInstanceId"]?
                             (
                                 `ID: ${original["nPackageInstanceId"]}`):""}
                        </span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Business Details",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        
						<span> {original["refBusinessSectorNew"] && original["refBusinessSectorNew"]["sSectorName"]}</span>
						<br></br><br></br>
						<span>{original["sBusinessName"]}</span>                          
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Facilitator Email",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>            
                        <span>{original["refFacilitator"]}</span>
          
                    </>
                )				
                },
                // {
                //     id: "sServiceCode",
                //     Header: "Service Detail",
                //     headerStyle:{'whiteSpace': 'unset',},
                //     accessor: "sServiceCode",
                //     //width: 200,	
				// 	//height:10,
                //     style:{'whiteSpace': 'unset'},
                //     //fixed:"left",
				// 	Cell:({original})=>
                // (
                //     <>
                        
				// 		<span>{original["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}}  title={original["sServiceCancellationReason"]?
				// 				original["sServiceCancellationReason"] ==="Other"? 
				// 				original["sServiceCancellationReasonOtherDescription"]: 
				// 				original["sServiceCancellationReason"]:""}>{original["refSRState"]}</span>):(original["refSRState"])}
				// 		</span> 
                //         <br></br>
                //         <span>
                //         {(original["dtDelivered"]?moment(moment.utc(original["dtDelivered"]).toDate()).format(
				// 			"MMMM Do YYYY, h:mm:ss a"
				// 		):null)}
                //         </span>          
                //     </>
                // )				
                // },
                {
                    id: "sServiceCode",
                    Header: "Status Date",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                    {/* <span>
                    {original["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}}  title={original["sServiceCancellationReason"]?
								original["sServiceCancellationReason"] ==="Other"? 
								original["sServiceCancellationReasonOtherDescription"]: 
								original["sServiceCancellationReason"]:""}>{original["refSRState"]}</span>):(original["refSRState"])}
                    </span> */}
                    <br></br>
                    <span>
                    {(original["dtDelivered"]?moment(moment.utc(original["dtDelivered"]).toDate()).format(
							"MMMM Do YYYY, h:mm:ss a"
						):null)}
                    </span>

                    
                         
                    </>
                )				
                },
                 
                {
                    id: "sServiceCode",
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'20%'},
                    Header: 
                    <div>Notes
                    <br></br>
                    <img
                        alt=""
                        src={arrow_left}
                        height={"20px"}
                        width={"20px"}
                        className="conv-float-right"
                        onClick={()=>{
                            setcolumnPage(0);
                        }}
                    />
                </div>,
                    accessor: "Delivered_to_Signed_Up",
                    //width: 200,
					Cell:({original})=>
					(
						<>
                            <Button onClick={() => props.toggleNotesModal(original)}>
							    Add Notes
						    </Button>     
						</>
					)				
                },
            );
        }

		return  (
			
			
			<div className="spled-container fix-filter">
			<div className="spled-container">
				<div className={`service-partner spled-container`}>
			 	  <ReactTableFixedColumns 
				   columns={columns} 
				   data={props.data || []} 
				   pageSize={props.data.length}
				   sortable={false}
				   showPagination={false}
				   style={{overflowY: "auto",height: "280px"}}			
				   className="-striped hide-scrollbar"
				   />

				 </div>
				</div>
				 </div>
			 	 		 
			   );	 
	};
	const renderServicesTableSPMSectionA = () => {
		if (!props.data) return;
		let temp = props.data.map((e) => {
			 
		});
		//return temp;
	};

  //End Service in spm Section-A//



//service From SPM section-B//
	const renderServicesTableColumnsSPMSectionB = () => {

		var columns= [];
		if(columnPage==0)
		{
            columns.push(
                {
                    id: "sServiceCode",
                    Header: "Service Name + Service ID",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        {/* <span>{getServiceName(original)}</span>
                        <br></br> */}
						<span> {original["refServiceType"]?.["sServiceName"]}</span>
                        
                        <br></br>
                        <span> ID: {original["nResourceInstanceId"]}</span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Package Details",
                    headerStyle:{'whiteSpace': 'unset','width':'10%'},
                    accessor: "sServiceCode",
                    //width: 150,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                         <span>{original["sPackageOfferTitle"]?original["sPackageOfferTitle"]:""}</span>
                        <br></br>
                        
                        <br></br>
                        <span>{original["nPackageInstanceId"]?
                             (
                                 `ID: ${original["nPackageInstanceId"]}`):""}
                        </span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Business Details",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 150,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        
						<span> {original["refBusinessSectorNew"] && original["refBusinessSectorNew"]["sSectorName"]}</span>
						<br></br><br></br>
						<span>{original["sBusinessName"]}</span>                          
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Service Status",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
					<span>
					{original["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}}  title={original["sServiceCancellationReason"]?
								original["sServiceCancellationReason"] ==="Other"? 
								original["sServiceCancellationReasonOtherDescription"]: 
								original["sServiceCancellationReason"]:""}>{original["refSRState"]}</span>):(original["refSRState"])}
					</span>
                            
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Followup Detail ",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 210,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                         
						<span>{original["sFollowupAction"]}</span>
                        
                        <br></br> 
                        <span>{(original["dtFollowupOn"]?moment(moment.utc(original["dtFollowupOn"]).toDate()).format(
							"Do MMMM YYYY, h:mm:ss a"
						):null)}</span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'10%'},
                    Header: 
                    <div>SR Email ID + User ID
                        <br></br>
                        <img
                            alt=""
                            src={arrow_right}
                            height={"20px"}
                            width={"20px"}
                            className="conv-float-right"
                            onClick={()=>{
                                setcolumnPage(1);
                            }}
                        />
                    </div>,
                    accessor: "sServiceCode",
                    width: 250,
					Cell:({original})=>
					(
						<>
							
							<span>{original["sEmailAddressOrigin"]}</span>  
							<br></br><br></br>

							<span className="conv-float-right">{original["nUserId"]}</span>
							 
							<span>{original["sContactNumber"]}</span>
							<br></br>
							
								
						</>
					)				
                },
                 
            );
        }
		else 
		{
            columns.push(
                {
                    id: "sServiceCode",
                    Header: "Service Name + Service ID",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        {/* <span>{getServiceName(original)}</span>
                        <br></br> */}
						<span> {original["refServiceType"]?.["sServiceName"]}</span>
                        
                        <br></br>
                        <span> ID: {original["nResourceInstanceId"]}</span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Package Details",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 150,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                         <span>{original["sPackageOfferTitle"]?original["sPackageOfferTitle"]:""}</span>
                        <br></br>
                        
                        <br></br>
                        <span>{original["nPackageInstanceId"]?
                             (
                                 `ID: ${original["nPackageInstanceId"]}`):""}
                        </span>
                              
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Business Details",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                        
						<span> {original["refBusinessSectorNew"] && original["refBusinessSectorNew"]["sSectorName"]}</span>
						<br></br><br></br>
						<span>{original["sBusinessName"]}</span>                          
                    </>
                )				
                },
                {
                    id: "sServiceCode",
                    Header: "Facilitator Email",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>            
                        <span>{original["refFacilitator"]}</span>
          
                    </>
                )				
                },
                // {
                //     id: "sServiceCode",
                //     Header: "Service Detail",
                //     headerStyle:{'whiteSpace': 'unset',},
                //     accessor: "sServiceCode",
                //     //width: 200,	
				// 	//height:10,
                //     style:{'whiteSpace': 'unset'},
                //     //fixed:"left",
				// 	Cell:({original})=>
                // (
                //     <>
                        
				// 		<span>{original["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}}  title={original["sServiceCancellationReason"]?
				// 				original["sServiceCancellationReason"] ==="Other"? 
				// 				original["sServiceCancellationReasonOtherDescription"]: 
				// 				original["sServiceCancellationReason"]:""}>{original["refSRState"]}</span>):(original["refSRState"])}
				// 		</span> 

                //         <span>
                //         {(original["dtDelivered"]?moment(moment.utc(original["dtDelivered"]).toDate()).format(
				// 			"MMMM Do YYYY, h:mm:ss a"
				// 		):null)}
                //         </span>                 
                //     </>
                // )				
                // },
                {
                    id: "sServiceCode",
                    Header: "Status Date",
                    headerStyle:{'whiteSpace': 'unset','width':'20%'},
                    accessor: "sServiceCode",
                    //width: 200,	
					//height:10,
                    style:{'whiteSpace': 'unset'},
                    //fixed:"left",
					Cell:({original})=>
                (
                    <>
                    {/* <span>
                    {original["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}}  title={original["sServiceCancellationReason"]?
								original["sServiceCancellationReason"] ==="Other"? 
								original["sServiceCancellationReasonOtherDescription"]: 
								original["sServiceCancellationReason"]:""}>{original["refSRState"]}</span>):(original["refSRState"])}
                    </span> */}

                    <span>
                    {(original["dtDelivered"]?moment(moment.utc(original["dtDelivered"]).toDate()).format(
							"MMMM Do YYYY, h:mm:ss a"
						):null)}
                    </span>
                         
                    </>
                )				
                },
                   
                {
                    id: "sServiceCode",
                    headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'20%'},
                    Header: 
                    <div>Notes
                    <br></br>
                    <img
                        alt=""
                        src={arrow_left}
                        height={"20px"}
                        width={"20px"}
                        className="conv-float-right"
                        onClick={()=>{
                            setcolumnPage(0);
                        }}
                    />
                </div>,
                    accessor: "Delivered_to_Signed_Up",
                    //width: 200,
					Cell:({original})=>
					(
						<>
                            <Button onClick={() => props.toggleNotesModal(original)}>
							    Add Notes
						    </Button>     
						</>
					)				
                },
            );
        }


		return  (
			
			
			<div className="spled-container fix-filter">
			<div className="spled-container">
				<div className={`service-partner spled-container`}>
			 	  <ReactTableFixedColumns 
				   columns={columns} 
				   data={props.data || []} 
				   pageSize={props.data.length}
				   sortable={false}
				   showPagination={false}
				   style={{overflowY: "auto",height: "280px"}}			
				   className="-striped hide-scrollbar"
				   />

				 </div>
				</div>
				</div> 
			   );
	};
	const renderServicesTableSPMSectionB = () => {
		if (!props.data) return;
		let temp = props.data.map((e) => { 
		});
		 
	};

    //Service from SPM section-B//

    if (!props.mainLoader && props.isLoading) {
        return (
            <div style={{ height: "250px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }
	return props.data ? (
		<>
			<div className="row">
				<div className="col-md-12" style={{marginBottom:'5px'}}>
					<span>
						<b>{props.label}</b>
					</span>
				</div>
				{/* {(props.SPMServices || props.label ==="Lead Details from LS") ? (
					""
				) : ( 
					<div
						style={{
							marginLeft:"83%",marginBottom:"1%"
						}}
						className={`${
							props.disableAssignToMe ? "" : "disable"
						} col-md-2`}
					>
						<Button
							style={{
								float: "right",
							}}
							onClick={() => props.assignToMeClick(props.nUserId)}
						>
							Assign to me
						</Button>
					</div>
				)} */}
			</div>
			{props.LSServices ? (
				<div style={{ marginTop: "10px" }}>
					{renderServicesTableLS()}
				</div>
			) 
			: 
			(
				<div style={{maxHeight:"300px"}}>
						<table className="tablescsss">
							<thead>
								{props.LSServices
									? ""
									: props.SPMServices
									? props.section === "A"
										? renderServicesTableColumnsSPMSectionA()
										: renderServicesTableColumnsSPMSectionB()
									: renderServicesTableColumnsLPM()}
							</thead>
							<tbody>
								{props.LSServices
									? ""
									: props.SPMServices
									? props.section === "A"
										? renderServicesTableSPMSectionA()
										: renderServicesTableSPMSectionB()
									: renderServicesTableLPM()}
							</tbody>
						</table>
					</div>
			)}
		</>
	) : (
		<div style={{marginLeft:"3%",marginBottom:"1%",fontWeight:"bold"}}>
			<span>
				<b>{props.label}</b>
			</span>
			<div>
				<span>
					<b>No data found</b>
				</span>
			</div>
		</div>
	);
}

/** */